/**
 * @description 导出默认网路配置
 **/
const network = {
  //配后端数据的接收方式application/json;charset=UTF-8 或 application/x-www-form-urlencoded;charset=UTF-8
  contentType: 'application/json;charset=UTF-8',
  //消息框消失时间
  messageDuration: 3000,
  //最长请求时间
  requestTimeout: 60000,
  //操作正常code，支持String、Array、int多种类型
  successCode: [1000, 0],
  //忽略token的请求
  ignoreRequest: ['/config/get', '/login', '/token/refresh'],
  //开启刷新token功能，开启了才会处理后端提供的token过期时间
  refreshToken: true,
  //距离到期时间多久时刷新，单位s
  refreshGapTime: 30 * 60,
}
module.exports = network
